import { useEffect, useState } from "react";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import CustomTable from "../../../components/common/CustomTable";
import { loadingReportMasterAsync } from "../../../redux/features/report-master/loadingReportMasterSlice";
import { handleLoadingReportMasterList } from "../../../Api/api";
import { useDispatch, useSelector } from "react-redux";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { useBoolean } from "../../../Hooks/useBoolean";
import { Box, Stack } from "@mui/material";
import DownloadReportButton from "../../../components/common/DownloadReportButton";
import CustomInput from "../../../components/common/CustomInput/CustomInput";
import CustomDropdown from "../../../components/common/CustomDropdown/CustomDropdown";
import { reportDropDownRecordAsync } from "../../../redux/features/report-master/reportDropDownRecordSlice";
import { useFormik } from "formik";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { BsFillEyeFill } from "react-icons/bs";
import groupBy from "lodash/groupBy";

export default function LoadingReport() {
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const [records, setRecords] = useState([]);

   const reportMasterList = useSelector(
      (state) => state.loadingReportMasterListSlice.data,
   );

   const columns = [
      {
         name: "Vehicle No.",
         selector: (row) => row?.vehicle_no,
         sortable: true,
      },
      {
         name: "Company Name",
         selector: (row) => row?.company_name,
         sortable: true,
      },
      {
         name: "Customer",
         selector: (row) => row?.customer,
         sortable: true,
      },

      {
         name: "Invoice No.",
         selector: (row) => row?.invoice_no,
         sortable: true,
      },
      {
         name: "Loading Date",
         selector: (row) =>
            row?.loading_date
               ? moment(row.loading_date).format("DD-MM-YYYY HH:mm:ss")
               : "",
         sortable: true,
      },

      {
         name: "Arrival Date",
         selector: (row) =>
            row?.arrival_date
               ? moment(row.arrival_date).format("DD-MM-YYYY HH:mm:ss")
               : "",
         sortable: true,
      },

      {
         name: "Receiving Date",
         selector: (row) =>
            row?.receiving_date
               ? moment(row.receiving_date).format("DD-MM-YYYY HH:mm:ss")
               : "",
         sortable: true,
      },

      {
         name: "Action",
         selector: (row) => (
            <button
               className="btn"
               onClick={() => navigate("/trip/contractual/edit/" + row.tripid)}
            >
               <BsFillEyeFill
                  className="text-primary"
                  style={{ height: "1.5rem", width: "1.5rem" }}
               />
            </button>
         ),
         width: "120px",
         center: true,
      },
   ];

   /// fetching filter drop down values
   const dropDownMaster = useSelector((state) => state.reportDropDownRecordSlice);

   const companyData = [
      { label: "Select..", value: "" },
      // {label:"All",value:"all"},
      ...(dropDownMaster?.data?.company_list?.map?.((item) => ({
         label: item?.company_name,
         value: item?.id,
      })) || []),
   ];

   const fleetData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.vehicle_list?.map?.((item) => ({
         label: item?.vehicle_no,
         value: item?.id,
      })) || []),
   ];

   const customerData = [
      { label: "Select..", value: "" },
      ...(dropDownMaster?.data?.customer_list?.map?.((item) => ({
         label: item?.name,
         value: item?.id,
      })) || []),
   ];

   const formik = useFormik({
      initialValues: {
         company: "",
         fleet: "",
         customer: "",
         loadingDateFrom: "",
         loadingDateTo: "",
      },

      //vlidationSchema: validationSchema,

      //onSubmit: handleAddVehicleDetails,
   });

   const {
      errors,
      values,
      touched,
      getFieldProps,
      handleSubmit,
      setFieldValue,
      resetForm,
   } = formik;

   const reportPopup = useBoolean();

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      const filter_params = {};
      if (values.customer) filter_params.customer_id = values.customer;
      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.loadingDateFrom)
         filter_params.loading_date_from = values.loadingDateFrom;
      if (values.loadingDateTo) filter_params.loading_date_to = values.loadingDateTo;

      dispatch(
         loadingReportMasterAsync({
            data: filter_params,
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, [
      values.customer,
      values.company,
      values.fleet,
      values.loadingDateFrom,
      values.loadingDateTo,
   ]);

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         reportDropDownRecordAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, []);

   useEffect(() => {
      if (reportMasterList) {
         const transformedRecords = Object.values(reportMasterList);

         const sortedRecords = transformedRecords.sort((a, b) => {
            let comp = a.company_name?.localeCompare(b.company_name);
            if (comp !== 0) return comp;

            comp = a.vehicle_no?.localeCompare(b.vehicle_no);
            if (comp !== 0) return comp;

            comp = a.customer?.localeCompare(b.customer);
            if (comp !== 0) return comp;

            return 0; // if all same
         });

         setRecords(sortedRecords);
      }
   }, [reportMasterList]);

   const handleDownloadReport = async (data) => {
      dispatch(backdropLoadingAction(true));

      const filter_params = { data };
      if (values.customer) filter_params.customer_id = values.customer;
      if (values.company) filter_params.company_id = values.company;
      if (values.fleet) filter_params.vehicle_id = values.fleet;
      if (values.loadingDateFrom)
         filter_params.loading_date_from = values.loadingDateFrom;
      if (values.loadingDateTo) filter_params.loading_date_to = values.loadingDateTo;

      try {
         const { data: response } = await handleLoadingReportMasterList(filter_params);
         if (response.statusCode !== 200) throw new Error(response.message || "Failed");
         const report_list = response.res;
         {
            const headers = [
               "S. No.",
               "Vehicle Number",
               "Company Name",
               "Customer",
               "Shipment / Challan No",
               "QTY",
               "Product Type",
               "Loading Date",
               "Arrival Date",
               "Receiving Date",
               "Loading Location",
               "Unloading Location",
               "RTKM",
               "Detention Days",
               "Shortage Qty",
               "Detention Chgs.",
               "Attached Location",
               "Driver Name",
            ];

            // Convert object to array
            let rows = Object.values(report_list);

            // =============================
            // SORTING (same as your code)
            // =============================
            rows.sort((a, b) => {
               let cmp;

               cmp = (a.vehicle_no ?? "").localeCompare(b.vehicle_no ?? "");
               if (cmp !== 0) return cmp;

               cmp = (a.company_name ?? "").localeCompare(b.company_name ?? "");
               if (cmp !== 0) return cmp;

               cmp = (a.customer ?? "").localeCompare(b.customer ?? "");
               if (cmp !== 0) return cmp;

               return 0;
            });

            // ==================================
            // GROUPING BY SORT ORDER
            // ==================================
            const groupKey = "vehicle_no";
            const grouped = rows.reduce((acc, item) => {
               const key = item[groupKey] || "Other";
               if (!acc[key]) acc[key] = [];
               acc[key].push(item);
               return acc;
            }, {});

            // ==================================
            // BUILD EXCEL ARRAY WITH TOTAL
            // ==================================
            const sumField = (items, field) =>
               items.reduce((sum, row) => sum + Number(row?.[field] || 0), 0);

            const excelArr = [];
            let serial = 1;

            Object.keys(grouped).forEach((vehicleNo) => {
               const groupRows = grouped[vehicleNo];

               // DATA ROWS
               groupRows.forEach((item) => {
                  excelArr.push([
                     serial++,
                     item.vehicle_no ?? "-",
                     item.company_name ?? "-",
                     item.customer ?? "-",
                     item.invoice_no ?? "-",
                     item.qty ?? "-",
                     item.product_type ?? "-",
                     item.loading_date
                        ? moment(item.loading_date).format("DD-MM-YYYY HH:mm:ss")
                        : "-",
                     item.arrival_date
                        ? moment(item.arrival_date).format("DD-MM-YYYY HH:mm:ss")
                        : "-",
                     item.receiving_date
                        ? moment(item.receiving_date).format("DD-MM-YYYY HH:mm:ss")
                        : "-",
                     item.loading_location ?? "-",
                     item.unloading_location ?? "-",
                     item.rtkm ?? "-",
                     item.detention_days ?? "-",
                     item.shortage ?? "-",
                     item.detention_charge ?? "-",
                     item.attached_location ?? "-",
                     item.driver_name ?? "-",
                  ]);
               });

               // VEHICLE TOTAL ROW
               excelArr.push(
                  [
                     "Total",
                     "",
                     "",
                     "",
                     "",
                     sumField(groupRows, "qty"),
                     "",
                     "",
                     "",
                     "",
                     "",
                     "",
                     sumField(groupRows, "rtkm"),
                     sumField(groupRows, "detention_days"),
                     sumField(groupRows, "shortage"),
                     sumField(groupRows, "detention_charge"),
                     "",
                     "",
                  ].map((x) => (x === undefined ? "" : x)),
               );

               excelArr.push([]); // blank row
            });

            // ==================================
            // EXPORT TO EXCEL
            // ==================================
            const sheetData = [headers, ...excelArr];

            const ws = XLSX.utils.aoa_to_sheet(sheetData);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

            XLSX.writeFile(wb, "LOADING REPORT.xlsx");

            dispatch(backdropLoadingAction(false));
            reportPopup.onFalse();
         }
      } catch (error) {
         dispatch(backdropLoadingAction(false));
         //toast.error(error.message || "Download failed");
      }
   };

   return (
      <div>
         <BodyHeader title="Loading Report" />
         <div className="px-3">
            {/* <div className="d-flex justify-content-between align-items-center mb-3"> */}
            {/* Left side: dropdowns */}
            <div className="row align-items-center">
               <div className="col-lg-2">
                  <CustomDropdown
                     label="Vehicle Number"
                     optionData={fleetData}
                     value={
                        fleetData.find((option) => option.value === values.fleet) ||
                        fleetData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("fleet", val || "");
                     }}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomDropdown
                     label="Company"
                     optionData={companyData}
                     value={
                        companyData.find((option) => option.value === values.company) ||
                        companyData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("company", val || "");
                     }}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomDropdown
                     label="Customer"
                     optionData={customerData}
                     value={
                        customerData.find((option) => option.value === values.customer) ||
                        customerData[0]
                     }
                     onChange={(value) => {
                        const val = Array.isArray(value) ? value[0]?.value : value?.value;
                        setFieldValue("customer", val || "");
                     }}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomInput
                     label="Loading Date From"
                     inputType="date"
                     placeholder="From"
                     {...getFieldProps("loadingDateFrom")}
                  />
               </div>
               <div className="col-lg-2">
                  <CustomInput
                     label="Loading Date To"
                     inputType="date"
                     placeholder="To"
                     {...getFieldProps("loadingDateTo")}
                  />
               </div>
               <div className="col-lg-2">
                  <button
                     type="button"
                     className="btn btn-outline-secondary w-100 mt-4"
                     onClick={() => resetForm()}
                  >
                     Clear Filters
                  </button>
               </div>
               <div className="col-lg-2 pt-2 mt-2 mb-2 text-right">
                  <DownloadReportButton
                     title="Download Report"
                     onDownloadReport={handleDownloadReport}
                     confirmPopup={reportPopup}
                     modal_title="Select Loading Date"
                  />
               </div>
            </div>
            {/* </div> */}

            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
